// 学习中心
const routes = [
    {
        path: '/learn',
        component: () => import('@/views/learning_center/index.vue'), // 首页
        meta: {
            title: '益学堂-学习中心',
        },
        // redirect: '/learn/recommend',
        children: [
            {
                path: '',
                // path: 'recommend',
                component: () => import('@/views/learning_center/recommend/index.vue'), // 推荐
                meta: {
                    keepAlive: true
                }
            },
            {
                path: 'follow',
                component: () => import('@/views/learning_center/follow/index.vue'), // 关注
            },
            {
                path: 'topic',
                component: () => import('@/views/learning_center/topic/index.vue'), // 专题
            },
            {
                path: 'course',
                component: () => import('@/views/learning_center/course/index.vue'), // 课程
            },
            {
                path: 'course/detail',
                component: () => import('@/views/learning_center/course/detail.vue'), // 课程详情
            },
            {
                path: 'message',
                component: () => import('@/views/learning_center/message/index.vue'), // 消息
            },
            {
                path: 'profile',
                component: () => import('@/views/learning_center/profile/index.vue'), // 个人主页
            },
        ]
    },
]

export default routes;